module.exports = __webpack_public_path__ + "img/supplier-no-vip-bg.90267a61.png";